<!-- =========================================================================================
    File Name: VxBreadcrumb.vue
    Description: Breadcrumb component
    Component Name: VxBreadcrumb
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div 
    class="vx-breadcrumb"
  >
    <ul class="flex flex-wrap items-center">
      <li class="inline-flex items-end">
        <router-link to="/">
          <VueFeather
            type="home"
            class="feather-icon feather-icon-css-target-1 inline-flex"
          />
        </router-link>
        <span class="breadcrumb-separator mx-2"><VueFeather
          :type="isRTL ? 'chevrons-left' : 'chevrons-right'"
          class="feather-icon feather-icon-css-target-2"
        /></span>
      </li>
      <li
        v-for="(link, index) in route.meta.breadcrumb.slice(1,-1)"
        :key="index"
        class="inline-flex items-center"
      >
        <router-link
          v-if="link.url"
          :to="link.url"
        >
          {{ link.title }}
        </router-link>
        <span
          v-else
          class="text-primary cursor-default"
        >{{ link.title }}</span>
        <span class="breadcrumb-separator mx-2 flex items-start"><VueFeather
          :type="isRTL ? 'chevrons-left' : 'chevrons-right'"
          class="feather-icon feather-icon-css-target-2 inline-flex"
        /></span>
      </li>
      <li class="inline-flex">
        <span
          v-if="route.meta.breadcrumb.slice(-1)[0].active"
          class="cursor-default"
        >{{ route.meta.breadcrumb.slice(-1)[0].title }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'VxBreadcrumb',
  props: {
    route: {
      type: Object,
      default: null
    },
    isRTL: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.feather-icon-css-target-1 :deep(.vue-feather__content) {
  height: 1.25rem;
  width: 1.25rem;
  margin-bottom: 0.25rem;
  stroke: currentColor !important;
  color: rgba(var(--vs-primary), 1) !important;
}
.feather-icon-css-target-2 :deep(.vue-feather__content) {
  width: 1rem !important;
  height: 1rem !important;
}
</style>
